import Form from "react-bootstrap/Form";
import SideBar from "../components/sideBar";
import translateText, {
  currentLanguage,
  LanguageDirection,
} from "../signals/language.signal";
import { useEffect, useState } from "react";
import { primary, primaryFount } from "../signals/Theme colors.signal";
import {
  fetchSearchProductApi,
  searchProductData,
} from "../signals/orderData.signal";
import { logClientNumber } from "../signals/login.signal";
import LazyImage from "../components/LazyImage";
import { Modal } from "react-bootstrap";
import { getCurrencySymbol } from "../components/CurrencySymbol";

const Product = () => {
  const [sku, setSku] = useState("");
  const [catalog, setCatalog] = useState("");
  const [serial, setSerial] = useState("");
  const [quantity, setQuantity] = useState("");
  const [type, setType] = useState("1");
  const [state, setState] = useState("1");
  const [numPiece, setNumPiece] = useState("");
  const [active, setActive] = useState(1);
  const [loading, setLoading] = useState(false);
  // const [addLoading, setAddLoading] = useState(false);
  const [whs, setWhs] = useState(0);
  const [disabled, setDisabled] = useState(false);
  // const [addDisabled, setAddDisabled] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);

  const [showModal, setShowModal] = useState(false);

  const handleShow = (data) => {
    setSelectedItem(data);
    // fetchDataDetail(order);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  useEffect(() => {
    searchProductData.value = null;
  }, []);
  const isActive = (isactive) => {
    return isactive === active
      ? { background: primary.value, color: primaryFount.value }
      : {};
  };
  const handleSku = (event) => {
    setSku(event.target.value);
  };
  const handleCatalog = (event) => {
    setCatalog(event.target.value);
  };
  const handleSerial = (event) => {
    setSerial(event.target.value);
  };
  const handleQuantity = (event) => {
    const newQuantity = event.target.value;
    setQuantity(newQuantity);
  };

  const handleType = (event) => {
    setType(event.target.value);
    if (event.target.value == 1) {
      setState(2);
      setNumPiece(1);
    } else {
      setState(1);
      setNumPiece();
    }
  };
  const handleNumPiece = (event) => {
    const newNumPiece = event.target.value;
    setNumPiece(newNumPiece);
  };
  const handleWhs = () => {
    whs == 0 ? setWhs(1) : setWhs(0);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setDisabled(true);
    searchProductData.value = null;
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      try {
        const response = await fetchSearchProductApi(
          logClientNumber.value,
          62,
          sku,
          active,
          catalog,
          type,
          serial,
          quantity,
          state,
          numPiece,
          whs,
          currentLanguage.value
        );

        if (response) {
          searchProductData.value = response;
        } else {
          searchProductData.value = null;
          console.error("Authentication failed");
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
        setDisabled(false);
      }
    }
  };

  return (
    <div
      id="Order"
      className="align-items-sm-center d-flex  justify-content-center flex-column w-100"
    >
      <SideBar
        more={true}
        showAccount={true}
        title={translateText(currentLanguage.value, "ProductTitle")}
      />
      <Form
        onSubmit={handleSubmit}
        className="align-items-sm-center d-flex justify-content-center w-100 p-3"
      >
        <div className="loginContaner  row bg-white p-3 p-md-5  w-100 shadow rounded-3 d-flex justify-content-center align-items-center">
          <div className="d-flex gap-2 w-100 mb-2">
            <p
              className="d-flex m-0 ps-2 pe-2 border border-1 justify-content-center align-items-center rounded-3"
              style={{
                ...isActive(1),
                fontSize: "12px",
                padding: "1px",
                width: "65px",
              }}
              onClick={() => {
                setActive(1);
                setSku("");
                setCatalog("");
                setSerial("");
                setQuantity("");
                setState("1");
                setNumPiece("");
              }}
            >
              {translateText(currentLanguage.value, "Product")}
            </p>
            <p
              className="d-flex m-0 ps-2 pe-2 border border-1 justify-content-center align-items-center rounded-3"
              style={{
                ...isActive(2),
                fontSize: "12px",
                padding: "1px",
                width: "65px",
              }}
              onClick={() => {
                setActive(2);
                setSku("");
                setCatalog("");
                setSerial("");
                setQuantity("");
                setState("1");
                setNumPiece("");
              }}
            >
              {translateText(currentLanguage.value, "Catalog")}
            </p>
            {/* <p
              className="d-flex m-0 ps-2 pe-2 border border-1 justify-content-center align-items-center rounded-3"
              style={{
                ...isActive(3),
                fontSize: "12px",
                padding:'1px',
                width: "65px",
              }}
              onClick={() => {
                setActive(3);
              }}
            >
              {translateText(currentLanguage.value, "QRcode")}
            </p> */}
          </div>
          {active === 1 ? (
            <div className="col-12 mb-2">
              <label htmlFor="Search" className="form-label">
                {translateText(currentLanguage.value, "ProductCode")}
              </label>
              <input
                type="text"
                className="form-control"
                id="Search"
                value={sku}
                onChange={handleSku}
                required
              />
            </div>
          ) : (
            <></>
          )}
          {active === 2 ? (
            <>
              <div className="col-6 mb-2">
                <label htmlFor="Catalog" className="form-label">
                  {translateText(currentLanguage.value, "CatalogNumber")}
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="Catalog"
                  value={catalog}
                  onChange={handleCatalog}
                  required
                />
              </div>
              <div className="col-6 mb-2">
                <label htmlFor="Serial" className="form-label">
                  {translateText(currentLanguage.value, "Serial")}
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="Serial"
                  value={serial}
                  onChange={handleSerial}
                  required
                />
              </div>
            </>
          ) : (
            <></>
          )}
          {active === 3 ? (
            <>
              <div
                className="col-12 mb-2 w-100"
                style={{ background: "#5b5b5b", height: 200, borderRadius: 8 }}
              ></div>
            </>
          ) : (
            <></>
          )}
          {active !== 3 ? (
            <>
              <div className="col-12 mb-2">
                <label htmlFor="Quantity" className="form-label">
                  {translateText(currentLanguage.value, "Quantity")}
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="Quantity"
                  value={quantity}
                  onChange={handleQuantity}
                  required
                />
              </div>
              <div className="col-12 mb-2">
                <label htmlFor="type" className="form-label">
                  {translateText(currentLanguage.value, "Type")}
                </label>
                <select
                  id="type"
                  className="form-select"
                  value={type}
                  onChange={handleType}
                >
                  <option value="1">
                    {translateText(currentLanguage.value, "Upholstery")}
                  </option>
                  <option value="2">
                    {translateText(currentLanguage.value, "Curtains")}
                  </option>
                  <option value="3">
                    {translateText(currentLanguage.value, "Cushion")}
                  </option>
                </select>
              </div>
              {type == "1" ? (
                <p className="w-100 text-danger">
                  {translateText(currentLanguage.value, "Wasalat")}
                </p>
              ) : (
                <></>
              )}
              {/* <div className="col-12 mb-2">
                <label htmlFor="State" className="form-label">
                  {translateText(currentLanguage.value, "State")}
                </label>
                <select
                  id="State"
                  className="form-select"
                  value={state}
                  onChange={handleState}
                >
                  <option value={"1"}>
                    {translateText(currentLanguage.value, "OnePiece")}
                  </option>
                  <option value={"2"}>
                    {translateText(currentLanguage.value, "SeveralPiece")}
                  </option>
                </select>
              </div> */}
            </>
          ) : (
            <></>
          )}

          {type == "2" || type == "3" ? (
            <>
              <div className="col-12 mb-2">
                <label htmlFor="smallerPiece" className="form-label">
                  {translateText(currentLanguage.value, "SmallerPiece")}
                </label>
                <input
                  type="number"
                  id="smallerPiece"
                  value={numPiece}
                  onChange={handleNumPiece}
                  required
                  className="form-control"
                />
              </div>
            </>
          ) : (
            <></>
          )}
          <div className="col-12 mb-2 d-flex align-items-center ">
            <input
              type="checkbox"
              id="WHS"
              value={whs}
              onChange={handleWhs}
              className="form-check-input mt-0"
              aria-label="Checkbox for following text input"
            />
            <label htmlFor="WHS" className="form-check pe-2 ps-2">
              {translateText(currentLanguage.value, "AllWhs")}
            </label>
          </div>

          <div className=" w-100 d-flex justify-content-end">
            <div className=" d-flex align-items-end ">
              <button
                type="submit"
                className="btn btn-primary border pe-3 ps-3 w-100"
                style={{ background: primary.value, color: primaryFount.value }}
                disabled={disabled}
              >
                {loading
                  ? translateText(currentLanguage.value, "Loading") + "..."
                  : translateText(currentLanguage.value, "Search")}
              </button>
            </div>
          </div>
        </div>
      </Form>
      {searchProductData.value ? (
        <div className="align-items-sm-center d-flex justify-content-center w-100 p-3">
          <div className="loginContaner bg-white p-3 p-md-5 flex-column w-100 shadow rounded-3 d-flex justify-content-center align-items-center">
            {searchProductData.value.status == "200" ? (
              <>
                <div className="mb-1 w-100  rounded-3 ">
                  <p className="form-label m-0" style={{ fontWeight: "700" }}>
                    {searchProductData.value.COLLECTIONANAME}
                  </p>
                  <hr className="mt-2" />
                </div>
                <div className="mb-3 p-0 border  w-100  rounded-3 bg-secondary-subtle">
                  <LazyImage
                    className="p-0 rounded-3"
                    src={searchProductData.value.IMGURL}
                    alt={searchProductData.value.COLLECTIONENAME}
                    style={{
                      height: "288px",
                      objectFit: "cover",
                      objectPosition: "center",
                    }}
                  />
                </div>
                <table cellPadding={0} cellSpacing={0} className="tayble w-100">
                  <tbody>
                    <tr>
                      <td valign="top">
                        <div style={{ fontWeight: "700" }}>
                          {translateText(currentLanguage.value, "Price")}
                        </div>
                      </td>
                      <td>
                        <div>
                          <p dir="ltr" style={{width:'fit-content'}}>
                            {" "}
                            {getCurrencySymbol('#000','10px','12px')}
                            {searchProductData.value.PRICE}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td valign="top">
                        <div style={{ fontWeight: "700" }}>
                          {translateText(currentLanguage.value, "Composition")}
                        </div>
                      </td>
                      <td>
                        <div> {searchProductData.value.COMPOSITION}</div>
                      </td>
                    </tr>
                    <tr>
                      <td valign="top">
                        <div style={{ fontWeight: "700" }}>
                          {translateText(currentLanguage.value, "Width")}
                        </div>
                      </td>
                      <td>
                        <div> {searchProductData.value.WIDTH} cm </div>
                      </td>
                    </tr>
                    <tr>
                      <td valign="top">
                        <div style={{ fontWeight: "700" }}>
                          {translateText(currentLanguage.value, "Weight")}
                        </div>
                      </td>
                      <td>
                        <div> {searchProductData.value.WEIGHT} gsm</div>
                      </td>
                    </tr>

                    <tr>
                      <td valign="top">
                        <div style={{ fontWeight: "700" }}>
                          {translateText(currentLanguage.value, "Country")}
                        </div>
                      </td>
                      <td>
                        <div> {searchProductData.value.COUNTRYE}</div>
                      </td>
                    </tr>
                    <tr>
                      <td valign="top">
                        <div style={{ fontWeight: "700" }}>
                          {translateText(currentLanguage.value, "Repository")}
                        </div>
                      </td>
                      <td>
                        <div> {searchProductData.value.WAREHOUSE}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                {/* <div className="mb-1 w-100 d-flex justify-content-end">
                  <div className="mb-1 d-flex align-items-end ">
                    <button
                      type="button"
                      className="btn btn-primary border pe-3 ps-3 w-100"
                      style={{
                        background: primary.value,
                        color: primaryFount.value,
                      }}
                      disabled={addDisabled}
                      onClick={() => {
                        setAddLoading(true);
                        setAddDisabled(true);
                        setTimeout(() => {
                          const existingCartData = getStorage("cartData");
                          const id = uuidv4();
                          searchProductData.value = {
                            ...searchProductData.value,
                            id: id,
                          };
                          const updatedCartData =
                            existingCartData.length != 0
                              ? [...existingCartData, searchProductData.value]
                              : [searchProductData.value];

                          setStorage("cartData", updatedCartData);
                          cartProductData.value = getStorage("cartData");
                          setAddLoading(false);
                          setAddDisabled(false);
                        }, 1000);
                        showToastMessageSuccess("Item Add to Cart");
                      }}
                    >
                      {addLoading
                        ? translateText(currentLanguage.value, "Loading") +
                          "..."
                        : translateText(currentLanguage.value, "addToCart")}
                    </button>
                  </div>
                </div> */}
              </>
            ) : (
              <div className="d-flex gap-3 align-items-center">
                <svg
                  width="50"
                  height="52"
                  viewBox="0 0 50 52"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-100"
                >
                  <g id="Group 67">
                    <g id="Layer 1">
                      <path
                        id="Vector"
                        d="M15.7309 31.7561C18.116 29.0956 20.5 26.4328 22.883 23.7677C23.5457 23.001 24.3588 22.3976 25.2649 22C23.9384 22.2587 22.7316 22.9807 21.8367 24.0511C19.5195 26.6464 17.198 29.2395 14.8723 31.8304L8.29893 39.1509C8.20035 39.559 8.0954 39.9639 8 40.3721C10.5759 37.4978 13.1529 34.6259 15.7309 31.7561Z"
                        fill="black"
                      />
                      <path
                        id="Vector_2"
                        d="M5.63257 47.9595C5.66105 48.0266 5.69429 48.0916 5.72752 48.1542C5.70616 48.0893 5.68479 48.0244 5.6658 47.9572L5.63257 47.9595Z"
                        fill="black"
                      />
                      <path
                        id="Vector_3"
                        d="M0.0876465 19.4587C0.120134 27.612 0.112637 35.7675 0.117635 43.9298C0.112637 35.7698 0.120134 27.6052 0.0876465 19.4385V19.4587Z"
                        fill="black"
                      />
                      <path
                        id="Vector_4"
                        d="M0.210728 44.738L0.134766 44.2477C0.148919 44.4125 0.174292 44.5762 0.210728 44.738Z"
                        fill="black"
                      />
                      <path
                        id="Vector_5"
                        d="M0.118164 44.1536L0.136188 44.2566C0.136188 44.1536 0.118164 44.0506 0.118164 43.9431V44.1536Z"
                        fill="black"
                      />
                      <path
                        id="Vector_6"
                        d="M2.23931 13.6695C6.39241 12.2376 10.5804 12.2455 14.7141 13.7321C16.318 14.3032 16.7248 15.2343 16.7054 16.4262C16.6241 20.6227 16.6744 24.8191 16.8914 29.0599C17.0309 28.7469 17.1664 28.4339 17.3059 28.121C17.0928 24.0315 17.0618 19.9811 17.1432 15.9229C17.1664 14.6997 16.7558 13.7425 15.1054 13.1557C10.8438 11.6299 6.559 11.6221 2.29742 13.0905C1.59201 13.3087 1.00026 13.6646 0.598906 14.112C0.197553 14.5593 0.00511226 15.0776 0.046536 15.5995V16.0794C0.0138429 15.5763 0.205105 15.0782 0.595794 14.6488C0.986483 14.2194 1.55879 13.8784 2.23931 13.6695Z"
                        fill="black"
                      />
                      <path
                        id="Vector_7"
                        d="M14.6652 15.6112C11.7624 14.7086 5.38673 14.7184 2.53248 15.6308C1.29093 16.0215 1.20698 16.3849 2.53248 16.6565C4.4412 17.0472 6.50899 17.2621 8.59002 17.5649C10.7418 17.2601 12.7742 17.057 14.6343 16.6838C16.0924 16.3908 15.9952 16.0274 14.6652 15.6112Z"
                        fill="black"
                      />
                      <path
                        id="Vector_8"
                        d="M12.9834 49.016C13.9818 49.2705 15.0093 49.4095 16.0432 49.4302C19.3666 49.5197 22.6709 49.6138 25.98 49.5511C27.7532 49.5153 29.2369 48.866 30.0772 47.1355C30.9175 45.405 32.0071 43.8133 32.9899 42.1589L39.1323 31.0148C39.1323 31.0148 36.9883 31.2748 35.6323 31.0148C34.051 30.7115 33.2379 29.893 31.6323 30.0148C29.3622 30.1869 26.625 33.0001 26.625 33.0001C26.625 33.0001 19.8033 41.2052 16.8313 44.7827C14.7875 47.2184 10.9656 46.8848 9.77873 44.1312C9.51921 43.5789 9.43578 42.9672 9.53864 42.3709C9.64149 41.7746 9.92617 41.2195 10.3579 40.7732C11.2363 39.7837 12.4113 39.6046 13.6813 39.8665C14.9513 40.1284 15.7346 41.2746 15.6919 42.591C15.6587 43.6566 14.7732 44.6685 13.6409 44.7849C13.2849 44.823 12.6748 44.6327 12.5632 44.3909C12.3258 43.876 12.8148 43.7193 13.3062 43.6297C13.9543 43.5245 14.4931 43.1395 14.3792 42.5104C14.2842 42.0022 13.94 41.3597 13.4961 41.1179C12.4683 40.5605 11.1437 41.2679 10.8849 42.3716C10.8063 42.6989 10.8044 43.0384 10.8794 43.3665C10.9543 43.6945 11.1043 44.0032 11.3188 44.271C11.5333 44.5387 11.8072 44.7591 12.1214 44.9167C12.4355 45.0743 12.7824 45.1653 13.1377 45.1834C15.5685 45.3267 17.1732 42.9917 16.1714 40.7329C15.4593 39.0964 13.686 38.2278 11.5757 38.4696C9.6007 38.6934 7.9058 40.2605 7.66367 42.0515C7.27911 44.805 9.81434 48.1743 12.9834 49.016Z"
                        fill="black"
                      />
                      <path
                        id="Vector_9"
                        d="M7.83839 47.0915C5.48409 43.1546 6.3386 40.53 8.62316 37.2493C8.76848 36.959 15.6676 29.68 15.6861 29.3755C15.6861 23.8882 15.6954 23.6162 15.6954 18.1271C15.6825 17.9669 15.6555 17.8073 15.6145 17.6491C8.74377 18.7544 7.5944 18.7517 2.16679 17.5649C2.13699 17.9478 2.08165 18.2927 2.08165 18.6376C2.08165 27.4126 2.08165 36.1868 2.08165 44.96C2.08165 47.1678 2.93304 47.8304 6.3386 48.2377C6.65361 48.273 7.07505 48.2133 7.26661 48.3246C7.64974 48.5473 8.1776 48.8677 8.13928 49.1393C8.10097 49.4109 7.40709 49.7041 6.97288 49.7259C5.38072 49.8163 3.79184 49.5312 2.50689 48.9247C1.22194 48.3182 0.330059 47.4323 0 46.4346L0.204334 47.3551C0.204334 49.0225 3.93342 50.3722 8.53092 50.3722C8.93533 50.3722 9.32697 50.3586 9.7101 50.3369C9.27249 49.5967 7.42001 47.8361 7.83839 47.0915Z"
                        fill="black"
                      />
                      <path
                        id="Vector_10"
                        d="M39.6184 30.002L39.0897 30.0263C40.2508 30.2964 40.6809 31.3957 39.9852 32.7273C37.152 38.167 34.3289 43.612 31.4223 49.0058C30.5825 50.5616 28.9382 50.856 27.4305 51.1963C26.6864 51.3482 25.9284 51.4071 25.1715 51.3718C21.6722 51.2746 18.1736 51.1522 14.676 51.0045C12.2197 50.9046 10.2592 49.7756 8.625 48.0011C10.3958 50.124 12.5384 51.4988 15.2957 51.6122C18.8878 51.7581 22.48 51.8841 26.0721 51.9903C26.8494 52.0254 27.6278 51.9638 28.3918 51.8067C29.9374 51.4583 31.6272 51.1558 32.4873 49.5595C35.4723 44.0199 38.3713 38.429 41.2804 32.8461C42.1279 31.2229 41.3513 29.9399 39.6184 30.002Z"
                        fill="black"
                      />
                      <path
                        id="Vector_11"
                        d="M18.8 40.5001L26.3 32.5001C26.3 32.5001 30.9671 28.8331 33.8 26.0001C35.3 24.5001 29.8937 26.1767 28.0013 24.5C26.231 22.9315 26.2573 21.2571 24.5 23C19.3722 28.1084 17.7513 30.2483 12.6344 35.3628C12.4311 35.5682 12.2639 35.8048 12.0344 36.0818C16.8835 36.116 18.8 40.5001 18.8 40.5001Z"
                        fill="black"
                      />
                    </g>
                    <path
                      id="Vector_12"
                      d="M31.3857 24C29.619 24 28.1132 23.3844 26.8685 22.1533C25.6228 20.9213 25 19.4316 25 17.6842C25 15.9368 25.6228 14.4472 26.8685 13.2152C28.1132 11.984 29.619 11.3684 31.3857 11.3684C33.1524 11.3684 34.6586 11.984 35.9042 13.2152C37.149 14.4472 37.7714 15.9368 37.7714 17.6842C37.7714 19.4316 37.149 20.9213 35.9042 22.1533C34.6586 23.3844 33.1524 24 31.3857 24ZM28.6718 20.3684C28.7995 20.4947 28.9485 20.5579 29.1188 20.5579C29.2891 20.5579 29.4381 20.4947 29.5658 20.3684L31.3857 18.5684L33.1737 20.3684C33.3014 20.4947 33.4504 20.5579 33.6207 20.5579C33.791 20.5579 33.94 20.4947 34.0677 20.3684C34.1954 20.2421 34.2593 20.0897 34.2593 19.9112C34.2593 19.7318 34.1954 19.5789 34.0677 19.4526L32.2797 17.6842L34.0996 15.8842C34.2273 15.7579 34.2912 15.6105 34.2912 15.4421C34.2912 15.2737 34.2273 15.1263 34.0996 15C33.9719 14.8737 33.8229 14.8105 33.6526 14.8105C33.4823 14.8105 33.3333 14.8737 33.2056 15L31.3857 16.8L29.5658 15C29.4381 14.8737 29.2891 14.8105 29.1188 14.8105C28.9485 14.8105 28.7995 14.8737 28.6718 15C28.5441 15.1263 28.4802 15.2737 28.4802 15.4421C28.4802 15.6105 28.5441 15.7579 28.6718 15.8842L30.4917 17.6842L28.6718 19.4842C28.5441 19.6105 28.4802 19.7579 28.4802 19.9263C28.4802 20.0947 28.5441 20.2421 28.6718 20.3684ZM47.8608 21.8526L40.5811 14.6526C40.3257 14.3789 40.0541 14.1002 39.7663 13.8164C39.4794 13.5318 39.1975 13.2632 38.9208 13.0105C39.7297 12.5053 40.3789 11.8316 40.8685 10.9895C41.358 10.1474 41.6028 9.22105 41.6028 8.21053C41.6028 6.63158 41.0443 5.28926 39.9272 4.18358C38.8093 3.07874 37.4521 2.52632 35.8557 2.52632C34.2593 2.52632 32.9021 3.07874 31.7842 4.18358C30.6671 5.28926 30.1086 6.63158 30.1086 8.21053C30.1086 8.33684 30.1141 8.45768 30.1252 8.57305C30.1354 8.68926 30.1511 8.81053 30.1724 8.93684C29.7893 8.97895 29.3687 9.06316 28.9106 9.18947C28.4534 9.31579 28.0438 9.46316 27.682 9.63158C27.6394 9.4 27.6075 9.16842 27.5862 8.93684C27.5649 8.70526 27.5543 8.46316 27.5543 8.21053C27.5543 5.91579 28.358 3.97347 29.9655 2.38358C31.5722 0.794526 33.5355 0 35.8557 0C38.1758 0 40.1396 0.794526 41.7471 2.38358C43.3538 3.97347 44.1571 5.91579 44.1571 8.21053C44.1571 9.11579 44.0136 9.97347 43.7267 10.7836C43.4389 11.5945 43.0396 12.3368 42.5287 13.0105L49.6488 20.0842C49.8829 20.3158 50 20.6105 50 20.9684C50 21.3263 49.8829 21.6211 49.6488 21.8526C49.4146 22.0842 49.1166 22.2 48.7548 22.2C48.3929 22.2 48.0949 22.0842 47.8608 21.8526Z"
                      fill="black"
                    />
                  </g>
                </svg>

                <h6 className="m-0">
                  {searchProductData.value
                    ? searchProductData.value.message
                    : translateText(currentLanguage.value, "ItemNotFound")}
                </h6>
              </div>
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
      {searchProductData.value ? (
        <div className="d-flex justify-content-center w-100 p-3 ">
          <div className=" loginContaner position-relative bg-white p-3 shadow rounded-3 w-100">
            <p className="m-0" style={{ fontWeight: "700" }}>
              {translateText(currentLanguage.value, "otherItem")}
            </p>
            <hr className="mt-2" />
            <div
              className=" position-relative d-flex align-items-center w-100"
              style={{
                overflowX: "auto",
                overflowY: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              <div
                className="d-flex p-1 flex-row position-relative justify-content-start align-items-center"
                style={{ gap: "10px", minWidth: "max-content" }}
              >
                {searchProductData.value.OTHER_ITEMS.map((item, index) => (
                  <div
                    key={index}
                    data-aos="zoom-in"
                    data-aos-duration="2000"
                    data-aos-delay={index * 200}
                    data-aos-anchor-placement="center-bottom"
                    className="loginContainer position-relative bg-white flex-column shadow-sm rounded-3 d-flex justify-content-between align-items-center"
                    style={{ width: "125px", height: "180px", flexShrink: 0 }}
                    onClick={() => handleShow(item)}
                  >
                    <div className="d-flex p-0 border h-100 w-100 rounded-3 bg-secondary-subtle">
                      <LazyImage
                        className="p-0 rounded-3 w-100 h-100"
                        src={item.IMGURL}
                        alt={item.COLLECTIONENAME}
                        style={{ objectFit: "cover", objectPosition: "center" }}
                      />
                    </div>
                    <p
                      className="form-label  w-75 shadow rounded-3 p-1 pr-3 pl-3 m-0 text-center position-absolute "
                      style={{
                        fontSize: "12px",
                        fontWeight: "700",
                        background: "rgb(0 0 0 / 40%)",
                        left: "-3px",
                        top: "-3px",
                        color: "#fff",
                      }}
                    >
                      {item.ARTCODE}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Modal
            show={showModal}
            onHide={handleClose}
            centered
            dir={LanguageDirection.value}
          >
            <Modal.Header closeButton>
              <div className="w-100  text-black">
                <div
                  className={
                    LanguageDirection.value === "rtl"
                      ? "text-start d-flex w-100 m-0"
                      : "text-end  d-flex w-100 m-0"
                  }
                >
                  <h6 className="m-0">
                    {selectedItem ? selectedItem.COLLECTIONENAME : ""}
                  </h6>
                </div>
              </div>
            </Modal.Header>
            <Modal.Body>
              <div className="progress-track text-dark">
                {selectedItem ? (
                  <div className="align-items-sm-center d-flex justify-content-center w-100 ">
                    <div className="flex-column w-100 d-flex justify-content-center align-items-center">
                      <>
                        <div className="mb-3 p-0 border  w-100  rounded-3 bg-secondary-subtle">
                          <LazyImage
                            className="p-0 rounded-3"
                            src={selectedItem.IMGURL}
                            alt={selectedItem.COLLECTIONENAME}
                            style={{
                              height: "288px",
                              objectFit: "cover",
                              objectPosition: "center",
                            }}
                          />
                        </div>
                        <table
                          cellPadding={0}
                          cellSpacing={0}
                          className="tayble w-100"
                        >
                          <tbody>
                            <tr>
                              <td valign="top">
                                <div style={{ fontWeight: "700" }}>
                                  {translateText(
                                    currentLanguage.value,
                                    "Price"
                                  )}
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p dir="ltr" style={{ width: "fit-content" }}>
                                    {" "}
                                    {getCurrencySymbol('#000','10px','12px')}
                                    {selectedItem.PRICE}
                                  </p>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td valign="top">
                                <div style={{ fontWeight: "700" }}>
                                  {translateText(
                                    currentLanguage.value,
                                    "Composition"
                                  )}
                                </div>
                              </td>
                              <td>
                                <div> {selectedItem.COMPOSITION}</div>
                              </td>
                            </tr>
                            <tr>
                              <td valign="top">
                                <div style={{ fontWeight: "700" }}>
                                  {translateText(
                                    currentLanguage.value,
                                    "Width"
                                  )}
                                </div>
                              </td>
                              <td>
                                <div> {selectedItem.WIDTH} cm </div>
                              </td>
                            </tr>
                            <tr>
                              <td valign="top">
                                <div style={{ fontWeight: "700" }}>
                                  {translateText(
                                    currentLanguage.value,
                                    "Weight"
                                  )}
                                </div>
                              </td>
                              <td>
                                <div> {selectedItem.WEIGHT} gsm</div>
                              </td>
                            </tr>

                            <tr>
                              <td valign="top">
                                <div style={{ fontWeight: "700" }}>
                                  {translateText(
                                    currentLanguage.value,
                                    "Country"
                                  )}
                                </div>
                              </td>
                              <td>
                                <div> {selectedItem.COUNTRYE}</div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </Modal.Body>
          </Modal>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Product;
